import { useTranslation } from "react-i18next";

const TransactionsItem = ({
    itemData
}) => {
    const { t } = useTranslation();

    return (
        <div className="grid grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2 bg-white rounded-lg p-2 dark:bg-slate-700">
            <div className="w-full">
                <div className="flex flex-col gap-1">
                    <p className="text-gray-400 text-[12px]">{t("admin_user_room_id")}:</p>
                    <p className="text-gray-500 text-[14px]">
                        {itemData.user_id}
                    </p>
                </div>
            </div>
            <div className="w-full">
                <div className="flex flex-col gap-1">
                    <p className="text-gray-400 text-[12px]">{t("admin_transaction_code")}:</p>
                    <p className="text-gray-500 text-[14px]">{itemData.trs_code}</p>
                </div>
            </div>
            <div className="w-full">
                <div className="flex flex-col gap-1">
                    <p className="text-gray-400 text-[12px]">{t("admin_amount")}:</p>
                    <p className={`text-[14px] ${itemData.type === 2 && "text-red-500"} ${itemData.type === 1 && "text-green-500"}`}>
                        {itemData.amount}
                    </p>
                </div>
            </div>
            <div className="w-full">

                <div className="flex flex-col gap-1">
                    <p className="text-gray-400 text-[12px]">{t("admin_status")}:</p>
                    <p className={`text-[14px] ${itemData.type === 2 && "text-red-500"} ${itemData.type === 1 && "text-green-500"}`}>
                        {itemData.type === 1 && t("admin_completed_success")}
                        {itemData.type === 2 && t("admin_completed_failure")}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default TransactionsItem;
